export const isOptionType = (x) => {
    return x !== null && x !== undefined && "value" in x;
};
class DefaultSelectOptionMapper {
    mapFunc;
    constructor(mapFunc) {
        this.mapFunc = mapFunc;
    }
    map(x) {
        if (x === undefined) {
            return x;
        }
        else {
            return {
                label: this.mapFunc(x),
                value: x
            };
        }
    }
    mapValueMulti(x) {
        if (x === undefined) {
            return x;
        }
        return x.map((v) => ({
            label: this.mapFunc(v),
            value: v
        }));
    }
    mapAll(x) {
        if (x === undefined) {
            return x;
        }
        return x.map((v) => ({
            label: this.mapFunc(v),
            value: v
        }));
    }
}
const DEFAULT_MAPPER = new DefaultSelectOptionMapper((x) => x);
export const customMapper = (mapFunc) => {
    return new DefaultSelectOptionMapper(mapFunc);
};
export const identityMapper = () => {
    return DEFAULT_MAPPER;
};
export const mapToSelectOption = (x) => {
    const mapper = identityMapper();
    if (Array.isArray(x)) {
        return mapper.mapValueMulti(x);
    }
    return mapper.map(x);
};
export const mapToSelectOptions = (x) => {
    return identityMapper().mapAll(x);
};
export const mapFromSelectOption = (x) => {
    if (x == null || !isOptionType(x)) {
        return undefined;
    }
    else {
        return x.value;
    }
};
export const mapFromSelectOptionMulti = (x) => {
    if (x == null || isOptionType(x)) {
        return [];
    }
    else if (isOptionType(x)) {
        return [x.value];
    }
    else {
        return x.map((x) => x.value);
    }
};
export function selectOnChangeWrapper(delegate) {
    return (x) => delegate(mapFromSelectOption(x));
}
export function selectOnChangeWrapperIfPresent(delegate) {
    return selectOnChangeWrapper((x) => {
        if (x !== undefined) {
            delegate(x);
        }
    });
}
export function selectOnChangeWrapperMulti(delegate) {
    return (x) => delegate(mapFromSelectOptionMulti(x));
}
